const getters = {
    token: state => state.user.token,
    roles: state => state.user.permissionList,
    userInfo: state => state.user.userInfo,
    permission_routes: state => state.permission.routes,
  }
  
  export default getters